/**
 *
 * CheckboxInput
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Label from 'components/Label';
import IconHolder from 'components/Icons/IconHolder';

import Tick from 'assets/allIcons/ui/icon_ui_tick.svg';

import CheckboxInputWrapper from './styles/CheckboxInputWrapper';
import CheckboxInputInput from './styles/CheckboxInputInput';
import CheckboxInputInputField from './styles/CheckboxInputInputField';


function CheckboxInput(props) {
  // eslint-disable-line react/prefer-stateless-function

  const {
    valueList,
    valueListIndex,
    onChange,
    readOnly,
    checked,
    id,
    name,
    value,
    label,
    thisStyles,
    thisLabelStyles,
    checkboxStylesCss,
    disabled,
    onClick
  } = props;




  const checkboxCssObject = {};
  const attributes = checkboxStylesCss ? checkboxStylesCss.replaceAll(/\s/g,'').split(';') : '';

  if (attributes) {
    for (var i = 0; i < attributes.length; i++) {
      let entry = attributes[i].split(':');
      entry = entry.filter(el => !!el);
      entry.length ? checkboxCssObject[entry.splice(0,1)[0]] = entry.join(':') : null;
    }
  }

  return (
    <CheckboxInputWrapper thisStyles={thisStyles} onClick={onClick}>
      <CheckboxInputInput
        checked={checked}
        disabled={disabled}
        id={id}
        name={name}
        onChange={!disabled ? () => onChange(valueList, valueListIndex) : nul}
        readOnly={readOnly}
        type={'checkbox'}
        value={value}
      />
      <CheckboxInputInputField htmlFor={id} $thisStyles={checkboxCssObject} $disabled={disabled} />
      {
        checked ? (
          <IconHolder icon={Tick} thisStylesWrapper={`
              position: absolute;
              top: 0px;
              left: 0px;
              vertical-align: middle;
              height: 2rem;
              width: 2rem;
              pointer-events: none;
            `}
            iconStyles={checkboxCssObject.tickColor ? `
              stroke: ${checkboxCssObject.tickColor};
            ` : `
              stroke: #000;
            `}
          />
        ) : ''
      }
      {/* <CheckboxInputIcon icon={Tick} thisStyles={checkboxCssObject}/> */}
      {
        label ? (
          <Label title={label} thisStyles={thisLabelStyles ? thisLabelStyles : `
            line-height: 2rem;
            margin-bottom: 1rem;
            margin-left: 1rem;
          `}/>
        ) : ''
      }

    </CheckboxInputWrapper>
  );

}

CheckboxInput.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  thisStyles: PropTypes.object,
  thisLabelStyles: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CheckboxInput;